import styled from "@emotion/styled";

import { theme } from "../../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Root = styled.span<{ color?: string; backgroundColor?: string }>(props => {
    const size = "16px";
    return {
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",

        textAlign: "center",
        verticalAlign: "center",

        fontSize: "12px",
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: size,
        fontVariantNumeric: "lining-nums",

        boxSizing: "border-box",
        height: size,
        minWidth: size,
        borderRadius: size,

        padding: "0 4px",
        marginLeft: "5px",

        color: props.color ?? theme(props).invertedColors.color,
        backgroundColor: props.backgroundColor ?? theme(props).brandColors.primaryColor,
    };
});
